export function setSearchParams(
  searchParams: URLSearchParams,
  replace = false,
): void {
  const newUrl = new URL(location.href);

  newUrl.search = searchParams.toString();

  const newUrlString = newUrl.toString();

  if (replace) {
    window.history.replaceState(
      { ...window.history.state, as: newUrlString, url: newUrlString },
      "",
      newUrlString,
    );
  } else {
    window.history.pushState(
      { ...window.history.state, as: newUrlString, url: newUrlString },
      "",
      newUrlString,
    );
  }
}
